import { State } from './type';

export const initialState: State = {
  paginate: {
    currentPage: 1,
    from: 0,
    lastPage: 0,
    perPage: 25,
    to: 0,
    total: 0
  },
  data: [],
  ui: {
    showModalPermission: false,
    showModalDeletePermission: false,
    permissionSelected: null,
    action: null
  }
};
